import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { AccountSelectors, ModulesSelectors } from '@serviceos-ng/core';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'serviceos-web-email-form',
    templateUrl: './email-form.component.html',
    styleUrls: ['./email-form.component.scss'],
})
export class EmailFormComponent implements OnInit, OnDestroy {
    @Select(AccountSelectors.email)
    public userEmail!: Observable<string>;

    @Select(
        ModulesSelectors.getComponentFromModule(
            'account',
            'account_settings_screen.contact_details.email'
        )
    )
    public emailConfig$!: Observable<{ title: string } | null>;

    public subscriptions: Subscription[] = [];

    constructor() {}

    ngOnInit(): void {
        this.subscriptions.push(this.userEmail.subscribe());
    }

    ngOnDestroy(): void {
        this.subscriptions.map((el) => el.unsubscribe());
    }
}
